module.exports = __webpack_public_path__ + "media/pricing/DigitalStorage-mobile-x2-2fa49080.png";